import defaultTheme from 'config/themes/default'
import React from 'react'

interface AttachmentProps {
  width?: number,
  height?: number,
  fill?: string
}

const Attachment = ({ fill= defaultTheme.composerIconColor, height = 16, width = 18 }: AttachmentProps) => {
  return (
    <svg
      className="drift-default-icon drift-default-icon--back-arrow"
      width={width}
      height={height}
      viewBox="0 0 16 18"
    >
      <path
        fill={fill}
        fillRule="evenodd"
        d="M8.078 16a.71.71 0 0 1-.513-.222.784.784 0 0 1 0-1.075l7.53-7.879c.562-.587.871-1.368.871-2.199 0-.83-.31-1.611-.87-2.197a2.883 2.883 0 0 0-4.204 0l-8.735 9.139c-.493.516-.73 1.012-.703 1.476.026.452.298.801.46.968.27.284.563.402.892.358.413-.054.888-.35 1.375-.86l6.854-7.172a.703.703 0 0 1 1.026 0 .784.784 0 0 1 0 1.074l-6.853 7.172c-.728.761-1.475 1.196-2.222 1.293-.783.102-1.509-.172-2.1-.79-.528-.553-.841-1.246-.881-1.952-.053-.917.326-1.805 1.125-2.64l8.735-9.14a4.292 4.292 0 0 1 6.257 0 4.706 4.706 0 0 1 1.296 3.271c0 1.236-.461 2.4-1.296 3.274l-7.53 7.879a.71.71 0 0 1-.514.222z"
      />
    </svg>
  )
}

export default Attachment
